import { useRef, useEffect } from 'react';

/**
 * 激活项的 DOM 选择器：`.panel-radio-bar` 内带 `active` 类名的 Checkboxbar 根节点
 * （见 Checkboxbar/index.tsx，active 类名加在 `.intelligence-genre-checkbox-bar.active`）
 */
const ACTIVE_ITEM_SELECTOR = '.panel-radio-bar .intelligence-genre-checkbox-bar.active';

/**
 * 在挂载及指定依赖变化时，把滚动容器内当前激活的品类项滚动到可视区。
 * 用于品类勾选面板关闭重开后恢复到激活项的可视位置，避免手动向下滚动。
 *
 * - 仅在激活项不在可视区时才滚动（`block: 'nearest'`），已在视口内时不动，不打扰用户。
 * - 找不到激活项或滚动容器时不报错，静默跳过。
 *
 * @param deps 触发重新定位的依赖数组（如激活索引、品类数据等）
 * @returns 挂载到滚动容器的 ref
 */
export default function useScrollActiveIntoView(deps: any[]): React.RefObject<HTMLDivElement> {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const activeItem = container.querySelector<HTMLElement>(ACTIVE_ITEM_SELECTOR);
    if (!activeItem) return;

    activeItem.scrollIntoView({ block: 'nearest' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return containerRef;
}
